import React,{ useState, useEffect, useRef } from 'react';

import star from '../../image/star.svg'
import starHalf from '../../image/star-half.svg'


const Star = ({score}) =>{
  return (
    <span style={{display:'flex'}}>
      {function(){
        let arr = []
        for(let i=1; i<=Math.floor(score);i++){
          arr.push(<img key={i} style={{width:16}} src={star} alt=""/>)
        }
        if(!Number.isInteger(score)){
          arr.push(<img key={score} style={{width:16}} src={starHalf} alt=""/>)
        }
        return arr
      }()}
    </span>
  )
}

export default Star